import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { JSX } from 'react';
import { AlertModel } from '../../model/Alert.model';

type Props = {
  alert: AlertModel | null;
  showAlert: (alert: AlertModel | null) => void;
}

export const AppAlert = ({ alert, showAlert }: Props): JSX.Element => {
  return alert
    ? <Snackbar autoHideDuration={alert.autoHide ? 4000 : null}
                open={!!alert}
                onClose={() => showAlert(null)}
                disableWindowBlurListener={true}
    >
      <Alert severity={alert.severity} sx={{ width: '100%' }}>
        <AlertTitle>{alert.title}</AlertTitle>
        {alert.description}
      </Alert>
    </Snackbar>
    : <></>;
};